module.exports = __webpack_public_path__ + "img/c98.398f6ac7.png";